@if (wbaAntragVersion === '2') {
  <ng-content select="[wbaVersionAeltere]"></ng-content>
}
@if (wbaAntragVersion === '3') {
  <ng-content select="[wbaVersionAlt]"></ng-content>
}
@if (wbaAntragVersion === '4') {
  <ng-content select="[wbaVersionAktuell]"></ng-content>
}
